import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Explore Section */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#FF9900]">Explore</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/partners" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  Partners
                </Link>
              </li>
              <li>
                <a 
                  href="https://www.amazon.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300"
                >
                  Amazon Storefront
                </a>
              </li>
              <li>
                <a 
                  href="https://www.target.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300"
                >
                  Target Storefront
                </a>
              </li>
              <li>
                <a 
                  href="https://reverb.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300"
                >
                  Reverb Storefront
                </a>
              </li>
            </ul>
          </div>

          {/* Company Section */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#FF9900]">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  About
                </Link>
              </li>
              <li>
                <Link to="/our-story" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/what-we-do" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  What We Do
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect Section */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#FF9900]">Connect</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/careers" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-[#FF9900] transition-colors duration-300">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-[#FF9900]">Contact Info</h3>
            <div className="space-y-3 text-gray-300">
              <p>Delaware, USA</p>
              <p>
                <a href="tel:+17046845721" className="hover:text-[#FF9900] transition-colors duration-300">
                  +1 704-684-5721
                </a>
              </p>
              <p>
                <a href="mailto:contact@eymellc.com" className="hover:text-[#FF9900] transition-colors duration-300">
                  contact@eymellc.com
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Social Media and Copyright */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-gray-400">
              © {currentYear} EYME LLC. All rights reserved.
            </div>
            
            <div>
              <h4 className="text-sm font-semibold mb-3 text-center md:text-left">Let's Be Social</h4>
              <div className="flex gap-4 justify-center md:justify-start">
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 hover:bg-[#FF9900] p-3 rounded-lg transition-all duration-300"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 hover:bg-[#FF9900] p-3 rounded-lg transition-all duration-300"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a 
                  href="https://linkedin.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-gray-800 hover:bg-[#FF9900] p-3 rounded-lg transition-all duration-300"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
